var _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 1,
    x2: 20,
    y2: 1,
    stroke: "#323429",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 9,
    x2: 20,
    y2: 9,
    stroke: "#323429",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 17,
    x2: 20,
    y2: 17,
    stroke: "#323429",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeTE9IjEiIHgyPSIyMCIgeTI9IjEiIHN0cm9rZT0iIzMyMzQyOSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHkxPSI5IiB4Mj0iMjAiIHkyPSI5IiBzdHJva2U9IiMzMjM0MjkiIHN0cm9rZS13aWR0aD0iMiIvPgo8bGluZSB5MT0iMTciIHgyPSIyMCIgeTI9IjE3IiBzdHJva2U9IiMzMjM0MjkiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";